import React from "react";
import { useSelector } from "react-redux";
import useAuthzBootstrap from "../hooks/useAuthzBootstrap";
import PageLoader from "../theme/GenericLoader/PageLoader";
import AccessDenied from "../Pages/AccessDenied/AccessDenied";
import {
  isAuthzAppAccessDenied,
  isAuthzAppType,
  isAuthzBootstrapPending,
} from "../utilities/authzPermissions";

/**
 * Runs /auth/me first. Only mounts children (AppDataInitializer, drawer, routes)
 * after UMS confirms access for this app — prevents business API calls on deny.
 */
export default function AuthzReadyGate({
  authenticated,
  appType,
  onLogout,
  children,
}) {
  useAuthzBootstrap({ authenticated, appType });
  const authzState = useSelector((state) => state.authzState);

  if (!authenticated || !isAuthzAppType(appType)) {
    return children;
  }

  if (isAuthzBootstrapPending(appType, authzState)) {
    return <PageLoader context="Loading permissions..." />;
  }

  if (isAuthzAppAccessDenied(appType, authzState)) {
    return <AccessDenied onLogout={onLogout} />;
  }

  return children;
}
